import React from "react"
import { Text } from "@capioweb/ui-components"
import { BlockCommonLayout } from "../../utils/layout"
import { UnitFilter, UnitList } from "./components"
import { UnitFilterContextProvider } from "./context/UnitFilterContext"
import { PropertyBoolean } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { Flex } from "@capioweb/ui-components/src"
import ContentLink, { ContentReference } from "../../@types/EpiFoundationSpa/Models/ContentLink"
import { getFilterQueryParams } from "../../utils/filterHistory"

export type UnitFilterValue = {
	id: string
	name: string
	children?: UnitFilterValue[]
}

export interface UnitItem {
	id: string
	icon: string
	displayName: string
	address: string
	url: string
	careTypeIds: string[]
	diagnoseIds: string[]
	regionId: string
	target: string
}

export interface UnitFilterProps {
	careTypesFilterValues: UnitFilterValue[]
	regionFilterValues: UnitFilterValue[]
	diagnoseFirstLevelFilterValues: UnitFilterValue[]
	diagnoseSecondLevelFilterValues: UnitFilterValue[]
	totalItems: number
	items: UnitItem[]
	disableCareTypeFilter: PropertyBoolean
	careTypeIds: string[]
	diagnoseIds: string[]
	blockId: number
}

export interface CapioNexusUnitFilterBlockProps {
	contentLink: ContentLink
	heading?: StringProperty
	units: UnitFilterProps
	disableCareTypeFilter: PropertyBoolean
	anchorId: StringProperty
	careTypeIds: string[]
	diagnoseIds: string[]
}

const CapioNexusUnitFilterBlock: React.FC<CapioNexusUnitFilterBlockProps> = (
	props
) => {
	const regionsFromQuery = getFilterQueryParams("regions")
	const caretypesFromQuery = getFilterQueryParams("caretypes")
	const careareasFromQuery = getFilterQueryParams("careareas")
	const diagnosesFromQuery = getFilterQueryParams("diagnoses")

	return props.units?.items?.length > 0 ? (
		<Flex flexDirection="column" id={props.anchorId?.value ?? ""}>
			{props.heading?.value && (
				<Text as="h2" variant="headline-2" textAlign="center" pt={3}>
					{props.heading.value}
				</Text>
			)}
			<UnitFilterContextProvider regionsFromQuery={regionsFromQuery} careTypesFromQuery={caretypesFromQuery} diagnosesFromQuery={careareasFromQuery} diagnosesLevel2FromQuery={diagnosesFromQuery}>
				<UnitFilter
					{...props.units}
					disableCareTypeFilter={props.disableCareTypeFilter}
				/>
				<BlockCommonLayout>
					<UnitList {...props.units} careTypeIds={props.careTypeIds} diagnoseIds={props.diagnoseIds} blockId={props.contentLink.id} />
				</BlockCommonLayout>
			</UnitFilterContextProvider>
		</Flex>
	) : null
}

export { CapioNexusUnitFilterBlock }
